
import { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import styled from "styled-components"
import { getAiChatMessagesById, setNewAiChat } from "../../features/ai/aiSlice"
import { IoMdAddCircleOutline } from "react-icons/io";

const Container = styled.div`
    width: 270px;
    max-height: 90vh;
    min-height: auto;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    color: ${({theme}) => theme.mainTextColor};
    margin-right: 20px;

    .akilli-kamyoon{
        background: linear-gradient(90deg, #5780EA 0%, #C4698E 100%);
        width: 100%;
        height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        font-size: var(--font-size-md);
        font-weight: var(--font-weight-xl);
        color: #fff;
    }

    .titles-list{
        display: flex;
        flex-direction: column;
        padding: 15px 0;
        padding-bottom: 10px;
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-top: none;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        max-height: 60vh;
        overflow: auto;

        &::-webkit-scrollbar {
            width: 0;
            width: 5px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({theme})=> theme.scrollThumbColor};
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }

        .date-grp-item{
            display: flex;
            flex-direction: column;

            .date-text{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                padding: 0 22px;
                color: var(--color-main);
            }

            .chat-date-list{
                display: flex;
                flex-direction: column;
                gap: 5px;
                margin: 5px 10px;

                .chat-item{
                    display: flex;
                    padding: 12px;
                    border-radius: 10px;
                    cursor: pointer;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 40px;

                    &:hover{
                        background-color: ${({theme}) => theme.secondaryBgColor};
                        padding-right: 5px;
                    
                        .more-icon{
                            display: inline;
                        }
                    }

                    .chat-text{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                    }

                    .more-icon{
                        font-size: 1.4rem;
                        color: ${({theme}) => theme.mainTextColor};
                        display: none;
                    }
                }
            }


        }
    }

    .top-container{
        display: flex;
        justify-content: flex-end;
        margin: 10px 0;

        .new-chat-btn{
        width: 30px;
        height: 30px;
        border: 2px solid #5780EA;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .add-icon{
            color: #5780EA;
            font-size: 1.2rem;
        }
    }
    }

   
`

const AiChatTitleContainer = () => {

    const {aiChatTitles, aiChatContent} = useSelector(state => state.ai)
    const [formattedList, setFormattedList] = useState([])
    const dispatch = useDispatch()

    const formatRelativeDate = (dateString) => {
        const date = new Date(dateString);
        const today = new Date();
        
        date.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        
        const diffInMs = today - date;
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
        
        if (diffInDays === 0) return "Bugün";
        if (diffInDays === 1) return "Dün";
        if (diffInDays < 30) return `${diffInDays} gün önce`;
        
        const diffInMonths = Math.floor(diffInDays / 30);
        return `${diffInMonths} ay önce`;
      }


    useEffect(() => {
        if(aiChatTitles.length > 0){
            const groupedData = Object.values(
                aiChatTitles.reduce((acc, obj) => {
                  // Tarihi sadece yıl-ay-gün olarak formatla
                  const dateKey = new Date(obj.createdAt).toISOString().split("T")[0];
                  
                  // Eğer bu tarih daha önce gruplamada yoksa, yeni bir obje oluştur
                  if (!acc[dateKey]) {
                    acc[dateKey] = {
                        date: formatRelativeDate(dateKey),
                        list: []
                    };
                  }
                  
                  // Objeyi ilgili tarih grubundaki listeye ekle
                  acc[dateKey].list.push(obj);
                  
                  return acc;
                }, {})
              );

              setFormattedList(groupedData)
        }
    },[aiChatTitles])

    const handleChatTitleClick = (chatId) => {
        dispatch(getAiChatMessagesById(chatId))
    }

  return (
    <Container>

        <div className="akilli-kamyoon">Akıllı Kamyoon</div>
        <div className="titles-list">
            {
                formattedList.map(item => (
                    <div className="date-grp-item">
                        <div className="date-text">{item.date}</div>
                        <div className="chat-date-list">
                            {
                                item.list.map(chat => (
                                    <div className="chat-item" onClick={() => handleChatTitleClick(chat.id)}>
                                        <div className="chat-text">{chat.title.length >= 26 ? `${chat.title.substring(0, 26)}...` : chat.title}</div>
                                        {/* <MdMoreVert className="more-icon"/> */}
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                ))
            }
        </div>

        {
            aiChatContent.chatId && 
            <div className="top-container">
                    <button className="new-chat-btn" onClick={() => dispatch(setNewAiChat())}>
                        <IoMdAddCircleOutline className="add-icon"/>
                    </button>
            </div>
        }

    </Container>
  )
}

export default AiChatTitleContainer